export default {
  diffusionInputs: 'Diffusionseingaben',
  partParameters: 'Teileparameter',
  simulationValues: 'Simulationswerte',
};
